import React, { ReactElement } from 'react';
import { saveData } from "services/api/saveData";
import { ModalProps } from "../ModalContext";
import JobModal from '../../../views/jobs/JobModal';

export const handleCreateJob = async ({
    itemId,
    initializeModal,
    setFloatingAlert,
    setButtonLoader,
    buttonAction,
    workflowId,
}: {
    itemId: number;
    initializeModal: (content: ReactElement<any>, props?: ModalProps, itemId?: number | null) => void; 
    setFloatingAlert: Function;
    setButtonLoader: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
    buttonAction: string;
    workflowId?: number;
}) => {
    // If no layout id is given, return
    if (!workflowId) return;

    try {
        // Start the button loader
        setButtonLoader((prev) => ({ ...prev, [buttonAction]: true }));

        // Configure the data object from the item data
        const submitData: Record<string, any> = {
            order_id: itemId,
        }

        // If a workflow id is given, add it to the submit data
        if (workflowId) {
            submitData.workflow = workflowId;
        }

        // Create the new job
        const response = await saveData({
            apiUrl: `post_job`,
            method: 'post',
            data: submitData
        });

        // Open the new job after succesfully creating
        if (response && response.status === 201) {
            const newJobId = response.data.id;

            if (newJobId) {
                initializeModal(
                    <JobModal itemId={newJobId} />,
                    { modalSize: 'large', itemId: newJobId }
                )
            }

            // Show success alert
            setFloatingAlert({
                type: 'success',
                message: 'validation.job.created_successfully',
            });
        }
    } catch (error) {
        setFloatingAlert({
            type: 'danger',
            message: 'validation.job.creation_failed',
        });
    } finally {
        // Stop the button loader
        setButtonLoader((prev) => ({ ...prev, [buttonAction]: false }));
    }
};